import { usePlayer } from "../../player/context.js";
import { usePopoverContext } from "../popover/context.js";
import { PopoverRoot } from "../popover/root.js";
import { VolumePopoverContextProvider } from "./context.js";
import { VolumePopoverCore } from "@videojs/core";
import { selectVolume } from "@videojs/core/dom";
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/volume-popover/root.tsx
const unavailableVolume = {
	volume: 0,
	muted: false,
	volumeAvailability: "unsupported",
	mutedAvailability: "unsupported",
	setVolume: () => 0,
	toggleMuted: () => false
};
/** Owns volume availability and the popover interaction lifecycle. */
function VolumePopoverRoot({ children, ...props }) {
	const volume = usePlayer(selectVolume);
	const [core] = useState(() => new VolumePopoverCore(props));
	core.setProps(props);
	core.setMedia(volume ?? unavailableVolume);
	return /* @__PURE__ */ jsx(PopoverRoot, {
		...props,
		children: /* @__PURE__ */ jsx(VolumePopoverState, {
			core,
			children
		})
	});
}
function VolumePopoverState({ core, children }) {
	const { popover } = usePopoverContext();
	core.setInput(popover.input.current);
	const state = core.getState();
	useEffect(() => {
		if (state.hidden) popover.close("imperative-action");
	}, [popover, state.hidden]);
	return /* @__PURE__ */ jsx(VolumePopoverContextProvider, {
		value: { state },
		children
	});
}
//#endregion
export { VolumePopoverRoot };

//# sourceMappingURL=root.js.map